import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-8"
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : ($setup.error)
      ? (_openBlock(), _createBlock($setup["ResourceErrorState"], {
          key: 1,
          kind: $setup.error.kind,
          "trace-id": $setup.error.traceId,
          "back-to": "/admin/accommodations",
          "back-label": "Vissza a szálláshelyekhez",
          onRetry: $setup.fetchData
        }, null, 8, ["kind", "trace-id"]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          fluid: ""
        }, {
          default: _withCtx(() => [
            ($setup.accommodationDetails)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createTextVNode("Szálláshely adatai"),
                            (!$setup.editing)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  variant: "text",
                                  color: "primary",
                                  "prepend-icon": "mdi-pencil",
                                  onClick: $setup.startEditing
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Szerkesztés")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.name,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event)),
                                    label: "Szálláshely neve",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('name')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.city,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.city) = $event)),
                                    label: "Város",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('city')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.address,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.address) = $event)),
                                    label: "Cím",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('address')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.billingAddress,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.billingAddress) = $event)),
                                    label: "Számlázási cím",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('billingAddress')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.phoneNumber,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.phoneNumber) = $event)),
                                    label: "Telefonszám",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('phoneNumber')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.email,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.email) = $event)),
                                    label: "E-mail",
                                    variant: "outlined",
                                    readonly: !$setup.editing,
                                    "hide-details": "auto",
                                    "error-messages": $setup.errorMessages('email')
                                  }, null, 8, ["modelValue", "readonly", "error-messages"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      ($setup.editing)
                        ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                disabled: $setup.saving,
                                onClick: $setup.cancelEditing
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Mégse")
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "flat",
                                loading: $setup.saving,
                                onClick: $setup.saveAccommodation
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Mentés")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode($setup["ProductsTableV2"], {
                    "table-data": $setup.accommodationDetails.products,
                    "accommodation-id": $setup.accommodationDetails.id
                  }, null, 8, ["table-data", "accommodation-id"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
}